// Счета в формах: какой счёт выбран, если пользователь его не трогал.
import type { AccountOptionDto } from "@home/shared";

/**
 * Счёт по умолчанию, как его выберет сервер: для личной операции (и перевода члену семьи) — свой личный
 * в этой валюте, иначе основной общий, иначе любой общий. Заначку сами не выбираем: в неё — только явно.
 */
export function defaultAccount(accounts: AccountOptionDto[], currency: "UZS" | "USD", personal: boolean): AccountOptionDto | null {
  const usable = accounts.filter((a) => !a.stash && a.currency === currency);
  return (
    (personal ? usable.find((a) => a.personal) : undefined) ??
    usable.find((a) => !a.personal && a.isDefault) ??
    usable.find((a) => !a.personal) ??
    usable[0] ??
    null
  );
}

/** Перевод между своими счетами без «откуда»: основной в этой валюте, иначе общий, иначе свой — не счёт «куда». */
export function defaultSource(accounts: AccountOptionDto[], currency: "UZS" | "USD", toAccountId: string): AccountOptionDto | null {
  const usable = accounts.filter((a) => !a.stash && a.currency === currency && a.id !== toAccountId);
  return usable.find((a) => !a.personal && a.isDefault) ?? usable.find((a) => !a.personal) ?? usable[0] ?? null;
}

/** Деньги кредита идут в остаток счёта, только если кредит взят, когда счёт уже вели (как на сервере). */
export function fundableAccounts(accounts: AccountOptionDto[], currency: "UZS" | "USD", startDate: string): AccountOptionDto[] {
  return accounts.filter((a) => a.currency === currency && startDate >= a.since);
}
